export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "3ebba09c-c828-4e11-813b-565b6c39faee";
export const MODAL_CLOSE_SEC = 3;
